// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg.svg-settings{pointer-events:none;position:absolute;top:0;left:0}.linear-stop1{stop-color:#00f0ff}.linear-stop2{stop-color:#33eb93}.fill-gradient-linear{fill:url(#linear)}.card__title{font-size:1.125rem;line-height:2rem;margin-bottom:1.5rem;font-weight:600;display:flex;align-items:center;color:var(--body)}.card__icon{margin-right:12px}.card__icon path{fill:url(#linear)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
